window.MTGGoldfishMetagame = window.MTGGoldfishMetagame || {};

window.MTGGoldfishMetagame.onDocumentReady = function() {
  function toggleButtonState(element, active) {
    if (!element) return;
    if (active) element.classList.add("disabled");
    else element.classList.remove("disabled");
  }

  function toggleClick(preference) {
    toggleButtonState(document.getElementById("toggle-online"), preference === "online");
    toggleButtonState(document.getElementById("toggle-paper"), preference === "paper");
    toggleButtonState(document.getElementById("toggle-arena"), preference === "arena");
  }

  function setToggle(selector, show) {
    document.querySelectorAll(selector).forEach(function(el) {
      el.style.display = show ? '' : 'none';
    });
  }

  var updateVisibilityForSelection = function(type) {
    if (type === "paper") {
      setToggle(".deck-price-paper", true);
      setToggle(".deck-price-online", false);
      setToggle(".deck-price-arena", false);
      document.querySelectorAll(".metagame-type-selection").forEach(function(el) { el.value = "paper"; });
    } else if (type === "online") {
      setToggle(".deck-price-paper", false);
      setToggle(".deck-price-arena", false);
      setToggle(".deck-price-online", true);
      document.querySelectorAll(".metagame-type-selection").forEach(function(el) { el.value = "online"; });
    } else {
      setToggle(".deck-price-paper", false);
      setToggle(".deck-price-arena", true);
      setToggle(".deck-price-online", false);
      document.querySelectorAll(".metagame-type-selection").forEach(function(el) { el.value = "arena"; });
    }
    var target = "#".concat(type);
    if (history.pushState) history.pushState(null, null, target);
    else window.location.hash = target;
  }

  var onlineToggle = document.getElementById('toggle-online');
  if (onlineToggle) {
    onlineToggle.addEventListener('click', function() {
      toggleClick("online");
      updateVisibilityForSelection("online");
    });
  }

  var paperToggle = document.getElementById('toggle-paper');
  if (paperToggle) {
    paperToggle.addEventListener('click', function() {
      toggleClick("paper");
      updateVisibilityForSelection("paper");
    });
  }

  // Initialize based on URL hash or cookie
  var url = document.location.toString();
  if (url.match('#paper')) {
    var preference = url.split('#')[1];
    var toggleEl = document.getElementById('toggle-' + preference);
    if (toggleEl) toggleEl.click();
    else updateVisibilityForSelection(preference);
  } else {
    var preference = Cookies.get('type-preference');
    if (preference !== "online") preference = "paper";
    history.replaceState(null, null, '#' + preference);
    var toggleEl = document.getElementById('toggle-' + preference);
    if (toggleEl) toggleEl.click();
    else updateVisibilityForSelection(preference);
  }

  window.addEventListener("popstate", function(e) {
    var popUrl = document.location.toString();
    if (popUrl.match('#')) {
      var toggleEl = document.getElementById('toggle-' + popUrl.split('#')[1]);
      if (toggleEl) toggleEl.click();
    }
  });
};
